module.exports = __webpack_public_path__ + "img/anticheat-circle.558552df.svg";